import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/Home.vue'
import Test from '@/views/Test.vue'
import Lessons from '@/views/Lessons.vue'
import Lesson from '@/views/Lesson.vue'
import LessonEdit from '@/views/LessonEdit.vue'
import LessonWords from '@/views/LessonWords.vue'
import LessonTest from '@/views/LessonTest.vue'
import Auth from '@/views/Auth.vue'
import TestResult from '@/views/TestResult.vue'
import { store } from '@/store'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      component: Home,
      meta: { requireAuth: true }
    },
    {
      path: '/about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue'),
    },
    {
      path: '/auth',
      component: Auth
    },
    {
      path: '/test',
      component: Test
    },
    {
      path: '/lessons',
      component: Lessons
    },
    {
      path: '/lesson/:id',
      component: Lesson,
      props: true,
      meta: { requireAuth: true },
      children: [
        {
          path: '',
          name: 'lessonEdit',
          component: LessonEdit
        },
        {
          path: 'words',
          name: 'lessonWords',
          component: LessonWords
        },
        {
          path: 'test/:testResultId?',
          name: 'lessonTest',
          component: LessonTest
        }
      ]
    },
    {
      path: '/test-result/:testResultId',
      name: 'testResult',
      component: TestResult,
      props: true
    }
  ],
})

router.beforeEach((to, from, next) => {
  const user = store.user
  const requireAuth = to.matched.some(record => record.meta.requireAuth)
  if (requireAuth && !user)
    next('/auth')
  else
    next()
})

export default router